/*
* ===============================================================================================================
*                                Copyright 2021, Blue Yonder Group, Inc.
*                                           All Rights Reserved
*
*                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
*                                          BLUE YONDER GROUP, INC.
*
*
*                         The copyright notice above does not evidence any actual
*                                 or intended publication of such source code.
*
* ===============================================================================================================
*/

import { IApplication, IModule, IOrganization, IRole } from "../../../models/Roles/RolesContracts";
import { getAllApplicationsForOrg, getAllModulesForApp, getAllOrganizations, getModuleById } from "../../../services/globalRole";
import { getBuiltinPoliciesForGlobalRole, getBuiltinPolicy } from '../../../services/policy';
import { showErrorAction } from "../../error/errorActionCreator";
import { hideLoader, showLoader } from "../../loader/loader";
import {
  getApplicationsForOrganizationAction,
  getModulesForApplicationAction,
  getOrganizationsListAction,
  setGlobalRoleBuiltinPolicies,
  addModuleAction,
  setBuiltinPoliciesToAssociate,
  clearBuiltinPoliciesToAssociate
} from './globalRoleActionCreator';
import { setSnackBarMessage } from '../../snackBar/snackBarActionCreator';
import { IBuiltinPoliciesSearch } from '../../../models/Policies/BuiltInPolicies';
import { SNACKBAR_ALERT_DEFAULT_PROPS } from '../../../components/GlobalRoleDetails/AddBuiltinPoliciesDialog/constants';

export async function getOrganizationList(dispatch: Function) {
  let organizations: IOrganization[] = [];
  let errorMessage = { info: "", message: '' };
  try {
    dispatch(showLoader);
    dispatch(showErrorAction(errorMessage));
    organizations = await getAllOrganizations();
    organizations = organizations.map((organization: IOrganization) => {
      return organization;
    });
    dispatch(getOrganizationsListAction(organizations));
    dispatch(hideLoader);
  } catch (error: any) {
    const errorMessage = {
      message: 'Error in fetching organization list: ' + error
    };
    organizations = [];
    dispatch(getOrganizationsListAction(organizations));
    dispatch(showErrorAction(errorMessage));
    dispatch(hideLoader);
  }
};

export async function getApplicationListByOrg(dispatch: Function, name: string) {
  let applications: IApplication[] = [];
  let errorMessage = { info: "", message: '' };
  try {
    dispatch(showLoader);
    dispatch(showErrorAction(errorMessage));
    applications = await getAllApplicationsForOrg(name);
    dispatch(getApplicationsForOrganizationAction(applications));
    dispatch(hideLoader);
  } catch (error: any) {
    const errorMessage = {
      message: 'Error in fetching data: ' + error
    };
    applications = [];
    dispatch(getApplicationsForOrganizationAction(applications));
    dispatch(showErrorAction(errorMessage));
    dispatch(hideLoader);
  }
};

export async function getModuleListByApp(dispatch: Function, name: string) {
  let modules: IModule[] = [];
  let errorMessage = { info: "", message: '' };
  try {
    dispatch(showLoader);
    dispatch(showErrorAction(errorMessage));
    modules = await getAllModulesForApp(name);
    dispatch(getModulesForApplicationAction(modules));
    dispatch(hideLoader);
  } catch (error: any) {
    const errorMessage = {
      message: 'Error in fetching data: ' + error
    };
    modules = [];
    dispatch(getModulesForApplicationAction(modules));
    dispatch(showErrorAction(errorMessage));
    dispatch(hideLoader);
  }
};

export async function fetchGlobalRoleBuiltinPolicies(dispatch: Function, role: IRole, locationName?: string) {
  try {
    const errorMessage = { info: '', message: '' };
    dispatch(showErrorAction(errorMessage));
    const builtinPolicies = await getBuiltinPoliciesForGlobalRole(role.id, locationName);
    dispatch(setGlobalRoleBuiltinPolicies(builtinPolicies, role.id));
    if (builtinPolicies.length === 0 && role.moduleId) {
      const module = await getModuleById(role.moduleId).catch(() => undefined);
      if (module) {
        dispatch(addModuleAction(module));
      }
    }
  } catch (error: any) {
    const errorMessage = {
      message: 'Error in fetching data: ' + error
    };
    dispatch(setGlobalRoleBuiltinPolicies([], role.id));
    dispatch(showErrorAction(errorMessage));
  }
}

export async function fetchBuiltinPoliciesToAssociate(dispatch: Function, queryParams: IBuiltinPoliciesSearch) {
  try {
    dispatch(
      setSnackBarMessage({
        ...SNACKBAR_ALERT_DEFAULT_PROPS,
        showSnackbar: false
      })
    );
    const builtinPolicies = await getBuiltinPolicy(queryParams);
    dispatch(setBuiltinPoliciesToAssociate(builtinPolicies.entities, builtinPolicies.meta.page));
  } catch (error: any) {
    dispatch(clearBuiltinPoliciesToAssociate());
    dispatch(
      setSnackBarMessage({
        ...SNACKBAR_ALERT_DEFAULT_PROPS,
        message: 'Error in fetching data: ' + error,
        severity: 'error'
      })
    );
  }
}
